import React from 'react';

export const TaskTags = ({
    fill = '#818998',
    width = 16,
    height = 16,
}: {
    fill?: string;
    width?: number;
    height?: number;
}) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 16 16"
        fill="none"
    >
        <g clipPath="url(#clip0_4343_967)">
            <path
                d="M10.9 16H5.1C4.54522 16 4.01298 15.7909 3.61951 15.4185C3.22605 15.046 3.00333 14.5404 3 14.012V3.68133L8 0L13 3.68133V14.0147C12.9959 14.5426 12.7729 15.0475 12.3795 15.4194C11.9861 15.7913 11.4543 16 10.9 16ZM4.4 4.46133V14.012C4.40111 14.1881 4.47535 14.3567 4.6065 14.4808C4.73766 14.605 4.91507 14.6747 5.1 14.6747H10.9C11.0849 14.6747 11.2623 14.605 11.3935 14.4808C11.5247 14.3567 11.5989 14.1881 11.6 14.012V4.46133L8 1.516L4.4 4.46133Z"
                fill={fill}
            />
            <path
                d="M8 5.71484C8.55228 5.71484 9 5.26713 9 4.71484C9 4.16256 8.55228 3.71484 8 3.71484C7.44772 3.71484 7 4.16256 7 4.71484C7 5.26713 7.44772 5.71484 8 5.71484Z"
                fill={fill}
            />
        </g>
        <defs>
            <clipPath id="clip0_4343_967">
                <rect width={width} height={height} fill="white" />
            </clipPath>
        </defs>
    </svg>
);
